import Vue from 'vue'
import vueCustomElement from 'vue-custom-element'
import 'document-register-element/build/document-register-element'; // IE polyfill
Vue.use(vueCustomElement)

import VLocations from './VLocations/VLocations.vue';
Vue.customElement('v-locations', VLocations)
